import type { ReactNode } from 'react';

export const symbol_local_drink: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M262-80q-23 0-40.5-15T202-133l-74-673q-3-30 17-52t50-22h570q30 0 50 22t17 52l-74 673q-2 23-19.5 38T698-80H262Zm-48-500 48 440h436l48-440H214Zm-7-60h546l20-180H187l20 180Zm239 373.5Q432-280 432-299q0-24 12.5-53t35.5-59q23 30 35.5 59t12.5 53q0 19-14 32.5T480-253q-20 0-34-13.5ZM556.5-224q31.5-31 31.5-75 0-51-26.5-97T502-477q-5-5-10.5-7t-11.5-2q-6 0-11.5 2t-10.5 7q-33 35-59.5 81T372-299q0 44 31.5 75t76.5 31q45 0 76.5-31ZM214-140h532-532Z"
		/>
	</svg>
);
